import { addError } from '@/store/reducers/ToastStore';
import { getChatAPI } from '@/api/ChatApi';
import { getLayoverLogger } from '@/logging/LayoverLogger';
import { getUserFromApi, User } from '@/models/User';

import { User as Auth0User } from '@auth0/auth0-spa-js';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const loginUser = createAsyncThunk<User | null, Auth0User | null>(
  'data/loginUser',
  async (auth0User, { dispatch }) => {
    try {
      const chatApi = getChatAPI();

      if (auth0User?.sub && auth0User?.email) {
        const { data } = await chatApi.login({
          anonymousUserId: chatApi.getAnonymousUserId(),
          auth0UserId: auth0User.sub,
          email: auth0User.email,
          nickname: auth0User.nickname,
          name: auth0User.name,
        });

        return getUserFromApi(data.user);
      } else {
        return {
          uuid: chatApi.getAnonymousUserId(),
          displayName: 'User',
        };
      }
    } catch (e: any) {
      getLayoverLogger().logError('Error initializing user state', e);
      dispatch(
        addError({
          text: 'Something went wrong. Please refresh or try again later.',
        }),
      );

      return null;
    }
  },
);
